var CheckboxCounterLoader = /** @class */ (function () {
    function CheckboxCounterLoader() {
        this.checkboxCounterClassName = 'js-checkbox-counter';
        var checkboxCounter = document.getElementsByClassName(this.checkboxCounterClassName);
        for (var i = 0; i < checkboxCounter.length; i++) {
            new CheckboxCounter(checkboxCounter[i]);
        }
    }
    return CheckboxCounterLoader;
}());
export default CheckboxCounterLoader;
var CheckboxCounter = /** @class */ (function () {
    function CheckboxCounter(checkboxCounter) {
        this.checkboxContainer = null;
        this.checkboxes = null;
        this.counter = 0;
        this.checkboxCounter = checkboxCounter;
        this.checkboxContainer = this.setCheckboxContainer();
        this.checkboxes = this.setCheckboxes();
        if (this.checkboxContainer) {
            this.bindEvents();
            this.setCounter();
        }
    }
    CheckboxCounter.prototype.bindEvents = function () {
        var me = this;
        if (this.checkboxes) {
            for (var i = 0; i < this.checkboxes.length; i++) {
                this.checkboxes[i].addEventListener('change', function () {
                    this.checked ? me.increaseCounter() : me.decreaseCounter();
                });
            }
        }
    };
    CheckboxCounter.prototype.decreaseCounter = function () {
        if (this.counter - 1 >= 0) {
            this.counter--;
        }
        this.updateDom();
    };
    CheckboxCounter.prototype.increaseCounter = function () {
        this.counter++;
        this.updateDom();
    };
    CheckboxCounter.prototype.setCheckboxes = function () {
        if (this.checkboxContainer) {
            return this.checkboxContainer.querySelectorAll('input[type="checkbox"]');
        }
        else {
            return null;
        }
    };
    CheckboxCounter.prototype.setCheckboxContainer = function () {
        var containerId = this.checkboxCounter.getAttribute('data-container-id');
        return containerId ? document.getElementById(containerId) : null;
    };
    CheckboxCounter.prototype.setCounter = function () {
        var checkbox;
        if (this.checkboxes) {
            for (var i = 0; i < this.checkboxes.length; i++) {
                checkbox = this.checkboxes[i];
                checkbox.checked ? this.increaseCounter() : this.decreaseCounter();
            }
        }
    };
    CheckboxCounter.prototype.updateDom = function () {
        if (this.counter > 0) {
            this.checkboxCounter.innerText = '(' + this.counter + ')';
        }
        else {
            this.checkboxCounter.innerText = '';
        }
    };
    return CheckboxCounter;
}());
export { CheckboxCounter };
